<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="495">
    <div class="white py-8 px-7">
      <v-row class="pb-7">
        <v-col cols="12">
          <p class="text-h6 font-weight-bold primary--text mb-2">
            STATUS DA APÓLICE
          </p>
          <p class="font-weight-medium primary--text mb-5">
            Cancelado no dia
            {{ formatDateToDDMMYYYY(item.cancelada_em) }}
            {{ item.motivo_cancelamento && item.motivo_cancelamento.descricao }}
          </p>
          <label class="form__label primary--text">
            Justificativa
          </label>
          <v-row class="mb-5 modal-details-status-policy__justify mt-2">
            <v-col cols="12" class="px-2 pt-3 pb-6">
              <div
                v-html="item.justificativa_cancelamento"
                class="modal-details-status-policy__div"
              />
            </v-col>
          </v-row>
          <BaseFormInput
            id-element="cancelDetailsPolicy"
            :value="item.cancelada_por && item.cancelada_por.nome"
            disabled
            label-text="Cancelado por:"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3">
          <BaseButton
            v-html="'OK'"
            class="secondary"
            @click="$emit('close')"
            width="100%"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
export default {
  data: () => ({
    formatDateToDDMMYYYY
  }),
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.modal-details-status-policy__
  &justify
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
  &div
    p img
      width: 100% !important
</style>
